import { Injectable } from '@angular/core';
import { AlertController, ToastController } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class AlertService {

  constructor(public alertCtrl    : AlertController,
              public toastCtrl    : ToastController,
              ) 
  { 
    
  }

  async presentAlert(header, msg) {
    const alert = await this.alertCtrl.create({
      header: header,
      message: msg,
      buttons: ['Ok']
    });

    await alert.present();
  }

  async presentToast(msg, color= '') {
    const toast = await this.toastCtrl.create({
      message: msg,
      duration: 2000,
      position: 'top',
      color: color,
      cssClass: 'custom-toast-style'
    });

    await toast.present();
  }
}
